import { type ReactNode } from "react";
import { EditorSection } from "@/features/sparxsEditor/components/molecules/editorSection/EditorSection";
import { EditorSectionPlaceholder } from "@/features/sparxsEditor/components/atoms/EditorSectionPlaceholder";
import {
  useSectionFormSelection,
  type UseSectionFormSelectionOptions,
} from "@/features/sparxsEditor/hooks/editor/useSectionFormSelection";

export type SectionFormShellProps = {
  formLabel: string;
  header: string;
  children: ReactNode;
  noContainer?: boolean;
  selectionOptions?: UseSectionFormSelectionOptions;
};

export const SectionFormShell = ({
  formLabel,
  header,
  children,
  noContainer,
  selectionOptions,
}: SectionFormShellProps) => {
  const { isSelected } = useSectionFormSelection(formLabel, selectionOptions);
  if (!isSelected) {
    return <EditorSectionPlaceholder />;
  }
  return (
    <EditorSection header={header} noContainer={noContainer}>
      {children}
    </EditorSection>
  );
};
